/* eslint-disable */
import React from 'react'
import {accounting} from 'accounting'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from './HeaderTablePrint'
import cookie from 'react-cookies'

class PrintRemainDriver extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentDidMount() {}

  render() {
    let {aggregation, printInfo, rightSectionPrint, centerSectionPrint, columns, singleDriver} = this.props
    var reporterName = cookie.load('name')

    return (
      <React.Fragment>
        <div className="printSection">
          <table
            className="printTable printReportTable landscapeTable exeptionTable"
            ref={(node) => (this.printPart = node)}
          >
            <HeaderTablePrint
              header="گزارش مانده رساننده"
              headerColSpan={17}
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={8}
              rightColSpan={5}
              centerColSpan={4}
              rightSection={rightSectionPrint}
              centerSection={centerSectionPrint}
              columns={columns}
            />
            <tbody>
              <th>ردیف</th>
              <th>شماره فاکتور</th>
              <th>شناسه فاکتور</th>
              <th>کد مشتری</th>
              {!singleDriver && <th>رساننده</th>}

              <th style={singleDriver ? {width: '80px'} : {}}>تحویل گیرنده</th>
              <th style={singleDriver ? {width: '80px'} : {}}>بازه تحویل</th>
              {!singleDriver && <th>زمان تحویل</th>}

              <th>آدرس</th>
              {!singleDriver && (
                <th>
                  تعداد کالای
                  <br /> پارت تحویل
                </th>
              )}
              {!singleDriver && (
                <th>
                  تعداد کالای
                  <br /> تحویل شده
                </th>
              )}
              {/* {!singleDriver && <th>تحویل</th>} */}

              <th style={singleDriver ? {width: '90px'} : {}} className="priceCell">
                بدهکار
              </th>
              <th style={singleDriver ? {width: '90px'} : {}} className="priceCell">
                پرداخت نقدی
              </th>
              <th style={singleDriver ? {width: '100px'} : {}} className="priceCell">
                پرداخت کارتخوان
              </th>
              <th style={singleDriver ? {width: '100px'} : {}} className="priceCell">
                پرداخت از قبل
              </th>
              <th style={singleDriver ? {width: '90px'} : {}} className="priceCell">
                مانده
              </th>

              {printInfo.map((items, index) => (
                <>
                  <tr key={'i' + index}>
                    <td>{index + 1}</td>
                    <td>{items.invoice.invoiceNum}</td>
                    <td>{items.invoice.invoiceId}</td>
                    <td>{items.customer.userCode}</td>
                    {!singleDriver && <td>{items.driver == null ? '-' : items.driver.name}</td>}

                    <td>{items.invoice.recipientName}</td>
                    <td>
                      {jMoment(items.planDate).format('jYY/jM/jD') +
                        ' , ' +
                        items.planTimeFrom.substr(0, 5) +
                        ' - ' +
                        items.planTimeTo.substr(0, 5)}
                    </td>
                    {!singleDriver && (
                      <td>
                        {items.dispatchDate === null ? '-' : jMoment(items.dispatchDate).format('jYY/jM/jD HH:mm')}
                      </td>
                    )}

                    <td>{items.invoice.address}</td>
                    {!singleDriver && <td className="smallTd">{items.totalInfo.totalCount}</td>}
                    {!singleDriver && <td className="smallTd">{items.totalInfo.deliveredCount}</td>}
                    {/* {!singleDriver && <td>{items.deliveredBetween ? 'در بازه' : 'خارج از بازه'}</td>} */}

                    <td className="priceCell">{accounting.formatMoney(items.totalInfo.payableAmount, '', ',')}</td>
                    <td className="priceCell">{accounting.formatMoney(items.payment.cash, '', ',')}</td>
                    <td className="priceCell">{accounting.formatMoney(items.payment.card, '', ',')}</td>
                    <td className="priceCell">{accounting.formatMoney(items.payment.prePaid, '', ',')}</td>
                    <td className="priceCell">{accounting.formatMoney(items.remainAmount, '', ',')}</td>
                  </tr>
                  {singleDriver && (
                    <tr>
                      <td className="longTd priceCell" style={{textAlign: 'right !important'}} colSpan={17}>
                        توضیحات : {items.invoice.description === null ? '' : items.invoice.description}
                      </td>
                    </tr>
                  )}
                </>
              ))}
              <tr>
                <td colSpan={!singleDriver ? 9 : 6}>مجموع</td>
                {!singleDriver && <td>{aggregation.totalInfo ? aggregation.totalInfo.totalCount : ''}</td>}
                {!singleDriver && <td>{aggregation.totalInfo ? aggregation.totalInfo.deliveredCount : ''}</td>}
                <td className="priceCell">
                  {accounting.formatMoney(aggregation.totalInfo ? aggregation.totalInfo.payableAmount : '', '', ',')}
                </td>
                <td className="priceCell">
                  {accounting.formatMoney(aggregation.payment ? aggregation.payment.cash : '', '', ',')}
                </td>
                <td className="priceCell">
                  {accounting.formatMoney(aggregation.payment ? aggregation.payment.card : '', '', ',')}
                </td>
                <td className="priceCell">
                  {accounting.formatMoney(aggregation.payment ? aggregation.payment.prePaid : '', '', ',')}
                </td>
                <td className="priceCell">{accounting.formatMoney(aggregation.remainAmount, '', ',')}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </React.Fragment>
    )
  }
}
export default PrintRemainDriver
